import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-view" }

import UserPanel from '@/components/UserPanel.vue';
import { useUserStore } from '@/services/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const userStore = useUserStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "aliceblue fira flex-vertical p-center" }, [
      _createElementVNode("p", { class: "large" }, "Welcome to Acumapify"),
      _createElementVNode("p", null, "Use one of the buttons on the left to get started!")
    ], -1)),
    _createVNode(UserPanel, {
      user: _unref(userStore).user
    }, null, 8, ["user"])
  ]))
}
}

})